// @ts-nocheck
import ko from 'knockout';
import component from 'mesitis/components/users/userCard/userCardChangePwd';

var componentName = 'user-card-changepwd-component';
    ko.components.register(componentName, component);
export default componentName;
